$(document).ready(function () {
    $('.js-gallery').each(function(){
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: window.Laravel.lang.lightbox.loading + ' ' + '#%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: window.Laravel.lang.lightbox.close,
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: window.Laravel.lang.lightbox.prev,
                tNext: window.Laravel.lang.lightbox.next,
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '<span class="mfp-counter">%curr%' +  ' ' +window.Laravel.lang.lightbox.with+ ' ' +  '%total%</span>'
            },
            image: {
                tError: '<a href="%url%">' + window.Laravel.lang.lightbox.error.part1 + '#%curr%</a>' + window.Laravel.lang.lightbox.error.part2 + '.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    });
});
